import { render, staticRenderFns } from "./CatalogoSubfactores.vue?vue&type=template&id=e0775db8&"
import script from "./CatalogoSubfactores.vue?vue&type=script&lang=js&"
export * from "./CatalogoSubfactores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports